import { z } from "zod";
import httpClient from "@/config/axios";
const shift = z.object({
  code: z.string(),
  name: z.string(),
  color: z.string(),
});
export const wantedReflectionSchema = z.object({
  year: z.number().int(),
  month: z.number().int(),
  issued: z.boolean(),
  submitted: z.boolean(),
  entries: z.array(
    z.object({
      date: z.string(),
      requested: shift,
      assigned: shift.nullable(),
      granted: z.boolean(),
      unknown: z.boolean(),
      comment: z.string().nullable(),
    })
  ),
  summary: z
    .object({
      total: z.number().nonnegative(),
      granted: z.number().nonnegative(),
      rejected: z.number().nonnegative(),
      unknown: z.number().nonnegative(),
      rate: z.number().min(0).max(100).nullable(),
    })
    .nullable(),
});
export type WantedReflection = z.infer<typeof wantedReflectionSchema>;
export async function fetchWantedReflection(
  year: number,
  month: number,
  signal?: AbortSignal
): Promise<WantedReflection> {
  const result = wantedReflectionSchema.parse(
    await httpClient.get<unknown>("/wanted/me/reflection", {
      params: { year, month },
      signal,
      skipGroupIdInjection: true,
    })
  );
  if (result.year !== year || result.month !== month)
    throw new Error("요청한 기간과 원티드 반영 내역이 일치하지 않습니다.");
  return result;
}
